/**
 * F1 Team Colors
 *
 * Static mapping of constructor slugs to their official team colors.
 * Used for consistent styling across all F1 Fantasy pages.
 */

export const TEAM_COLORS: Record<string, string> = {
  // 2024-2025 Teams
  mclaren: "#FF8000",
  ferrari: "#DC0000",
  "red-bull-racing": "#1E41FF",
  mercedes: "#00D2BE",
  "aston-martin": "#006F62",
  alpine: "#0090FF",
  williams: "#005AFF",
  rb: "#6692FF",
  "racing-bulls": "#6692FF",
  haas: "#B6BABD",
  sauber: "#52E252",

  // 2026 Teams (new entries)
  audi: "#BB0A30",
  cadillac: "#C5A572",

  // Historical Teams (2020-2023)
  alphatauri: "#2B4562",
  "alphatauri-honda": "#2B4562",
  "alphatauri-rbpt": "#2B4562",
  "alfa-romeo": "#900000",
  "alfa-romeo-racing": "#900000",
  "red-bull-racing-honda": "#1E41FF",
  "red-bull-racing-rbpt": "#1E41FF",
  "racing-point": "#F596C8",
  renault: "#FFF500",
};

/**
 * Get the team color for a constructor
 * @param constructorSlug - The slug of the constructor (e.g., "mclaren", "ferrari")
 * @returns The hex color code for the team, or a default gray if not found
 */
export function getTeamColor(constructorSlug: string): string {
  return TEAM_COLORS[constructorSlug] || "#888888";
}

/**
 * Get a lighter version of the team color for backgrounds
 * @param constructorSlug - The slug of the constructor
 * @param opacity - The opacity level (0-1), default 0.2
 * @returns The team color with opacity for use in backgrounds
 */
export function getTeamColorWithOpacity(
  constructorSlug: string,
  opacity = 0.2,
): string {
  const color = getTeamColor(constructorSlug);
  // Convert hex to rgba
  const r = Number.parseInt(color.slice(1, 3), 16);
  const g = Number.parseInt(color.slice(3, 5), 16);
  const b = Number.parseInt(color.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
